import DosingRow from 'components/DosingRow/DosingRow';
import DosingTitle from 'forms/DosingInfo/DosingTitle/DosingTitle';

const NarcoTitratedDosing = () => {
  return (
    <div
      className="tab-pane"
      id="pills-titrated-1"
      role="tabpanel"
      aria-labelledby="pills-titrated-tab-1"
      tabIndex={0}
    >
      <div className="dosing-form-container">
        <DosingTitle
          title="Titrated XYWAV Dosing: Titrate to Effect"
          subtitle="2 times a night dosing (For Narcolepsy and IH)"
        />
        <DosingRow
          title="Starting Dose"
          withOperators
          fields={{
            doses: [
              'rems:titratedDosing:effect:nih:startingDose:dose:1',
              'rems:titratedDosing:effect:nih:startingDose:dose:2',
            ],
            totalDose: 'rems:titratedDosing:effect:nih:startingDose:dose:total',
            timeOfDrugTaking: 'rems:titratedDosing:effect:nih:startingDose:dose:numOfDays',
          }}
          timeOfDrugTakingInformation={true}
        />
        <DosingRow
          title="1st Titration"
          withOperators
          fields={{
            doses: [
              'rems:titratedDosing:effect:nih:1stTitration:dose:1',
              'rems:titratedDosing:effect:nih:1stTitration:dose:2',
            ],
            totalDose: 'rems:titratedDosing:effect:nih:1stTitration:dose:total',
            timeOfDrugTaking: 'rems:titratedDosing:effect:nih:1stTitration:dose:numOfDays',
          }}
        />
        <DosingRow
          title="2nd Titration"
          withOperators
          fields={{
            doses: [
              'rems:titratedDosing:effect:nih:2ndTitration:dose:1',
              'rems:titratedDosing:effect:nih:2ndTitration:dose:2',
            ],
            totalDose: 'rems:titratedDosing:effect:nih:2ndTitration:dose:total',
            timeOfDrugTaking: 'rems:titratedDosing:effect:nih:2ndTitration:dose:numOfDays',
          }}
        />
        <DosingRow
          title="3rd Titration"
          withOperators
          fields={{
            doses: [
              'rems:titratedDosing:effect:nih:3rdTitration:dose:1',
              'rems:titratedDosing:effect:nih:3rdTitration:dose:2',
            ],
            totalDose: 'rems:titratedDosing:effect:nih:3rdTitration:dose:total',
            timeOfDrugTaking: 'rems:titratedDosing:effect:nih:3rdTitration:dose:numOfDays',
          }}
        />
      </div>
      <div className="small pt-3 fw-bold">
        <div>
          Doses may be divided equally or unequally and the first dose taken at bedtime and the
          second dose taken 2.5 to 4 hours later.
        </div>
        <div>
          *For pediatric patients who sleep more than 8 hours per night, the first dose of XYWAV may
          be given at bedtime or after an initial period of sleep.
        </div>
        <div>
          **If XYWAV is used in patients 7 years of age and older who weigh less than 20 kg, a lower
          starting dosage, lower maximum weekly dosage increases, and lower total maximum nightly
          dosage should be considered.
        </div>
      </div>
    </div>
  );
};

export default NarcoTitratedDosing;
